/**
 * API endpoint paths
 */

export const ENDPOINTS = {
  START_SESSION: '/api/v1/start-session',
  GET_WIDGET_PARAMS: '/api/v1/get-widget-params',
  SEARCH: '/api/v1/search',
  SEARCH_BY_PHOTO: '/api/v1/search-by-photo',
  SEGMENT_CLICK: '/api/v1/segment-click',
  SEARCH_BY_IMAGE_CROP: '/api/v1/search-by-image-crop',
  SUGGEST: '/api/v1/suggest',
};
